import { MNSproCloudApi } from '..';
import { ReportDownload, parseReportFileName, toPdfBlob } from './reportDownload';

/**
 * Result of an evacuation report download.
 *
 * @deprecated Use {@link ReportDownload} instead — kept as an alias so existing
 * consumers keep compiling.
 */
export type EvacuationReportDownload = ReportDownload;

const DEFAULT_FILE_NAME = 'evacuation-list.pdf';

/**
 * Service for the evacuation list report (Evakuierungsliste).
 *
 * The backend generates the report as a PDF from live data
 * (`GET /api/v2/EvacuationReport/{organizationId}`), so the response is
 * downloaded as a binary blob rather than JSON.
 *
 * @class EvacuationReportService
 */
const EvacuationReportService = {
  /**
   * Downloads the organization's evacuation list as a PDF.
   *
   * @static
   * @param {string} authToken JWT (without 'Bearer'-prefix)
   * @param {string} organizationId
   * @return {*}  {Promise<ReportDownload>} the PDF blob and its file name
   * @memberof EvacuationReportService
   */
  async download(authToken: string, organizationId: string): Promise<ReportDownload> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.EvacuationReportApiFactory(config);

    const response = await api.getEvacuationList(organizationId, undefined, {
      responseType: 'blob',
    });

    return {
      blob: toPdfBlob(response.data),
      fileName: parseReportFileName(response.headers?.['content-disposition'], DEFAULT_FILE_NAME),
    };
  },
};

export { EvacuationReportService };
